export default "__VITE_ASSET__YrF7uox4__"